import { cleanLeadingZeros } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";

export const sahayDocumentArray = [
  {
    subSahayName: "Arthik Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Rental Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Senior Citizen Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Mahila Utkarsh Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Widow Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Jeevan Nirvah Sahay",
    documentData: [
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Viklang Utkarsh Sahay",
    documentData: [
      {
        documentType: "Handicap Certificate",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "School fee/Books/Uniform Orginal bill",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Medical bills/Prescription/Hospital bill",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Skill Development Sahay",
    documentData: [
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: true,
        isRequired: true,
      },

      // {
      //   documentType: "Last Mark Sheet",
      //   file: [],
      //   isUpload: false,
      // },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },

      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },

      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Mediclaim Premium Sahay",
    documentData: [
      {
        documentType: "Policy /Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Medicine Sahay",
    documentData: [
      {
        documentType: "Doctor Prescription",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Medicine Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Policy /Receipt",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Medical Sahay",
    documentData: [
      {
        documentType: "Policy /Receipt",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "Doctor Prescription",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Medicine Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Hospital bill/ Report",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Hospital Discharge card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Discharge Summary",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "Settlement Letter",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Hospitalisation Sahay",
    documentData: [
      {
        documentType: "Policy /Receipt",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Doctor Prescription",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Medicine Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Hospital bill/ Report",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      // {
      //   documentType: "Hospital Discharge card",
      //   file: [],
      //   isUpload: true,
      //   isRequired: true,
      // },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Discharge Summary",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Settlement Letter",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Heart Relief",
    documentData: [
      {
        documentType: "Policy /Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Doctor Prescription",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Medicine Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Hospital bill/ Report",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Hospital Discharge card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form Jr kg Sr kg",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form New 1 to 4",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form 5 to 15",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form 5 to 9",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form 10 to 12",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form 13 to 15",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form Further studies Post Graduation",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "College or Institute Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
    ],
  },
  {
    subSahayName: "Education Relief Form Reloving Loan",
    documentData: [
      {
        documentType: "Repayment Applicable",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "School /College Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "College or Institute Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Tutorial Releief Form New SSC & HSC",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType:
          "Tutorial Class / Institute Bonafide Certificate with Fees Structure",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Educational Loan",
    documentData: [
      {
        documentType: "Last Mark Sheet",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Fee Receipt",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
  {
    subSahayName: "Swawlamban",
    documentData: [
      // {
      //   documentType: "Last Mark Sheet",
      //   file: [],
      //   isUpload: false,
      // },
      {
        documentType: "Cheque",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Aadhar Card",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Elecrticity Bill",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Form Upload",
        file: [],
        isUpload: true,
        isRequired: false,
      },
      {
        documentType: "PAN",
        file: [],
        isUpload: true,
        isRequired: true,
      },
      {
        documentType: "Pay Slip",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Income Tax Return",
        file: [],
        isUpload: false,
        isRequired: false,
      },
      {
        documentType: "Rent Receipt/Agreement",
        file: [],
        isUpload: false,
        isRequired: false,
      },
    ],
  },
];

// export const sahayDocumentArray = [
//     {
//       subSahayName: "Arthik Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: true,
//         },
//       ],
//     },
//     {
//       subSahayName: "Rental Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Bhada chiti",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: true,
//         },
//       ],
//     },
//     {
//       subSahayName: "Senior Citizen Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: true,
//         },
//       ],
//     },
//     {
//       subSahayName: "Mahila Utkarsh Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: true,
//         },
//       ],
//     },
//     {
//       subSahayName: "Widow Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: true,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Jeevan Nirvah Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Viklang Utkarsh Sahay",
//       documentData: [
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Handicap Certificate",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "School fee/Books/Uniform Orginal bill",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Medical bills/Prescription/Hospital bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Skill Development Sahay",
//       documentData: [
//         {
//           documentType: "Repayment Applicable",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Aadhar",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Mediclaim Premium Sahay",
//       documentData: [
//         {
//           documentType: "Policy /Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Light Bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Medicine Sahay",
//       documentData: [
//         {
//           documentType: "Doctor Prescription",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Medicine Bill",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Medical Sahay",
//       documentData: [
//         {
//           documentType: "Policy /Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Doctor Prescription",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Medicine Bill",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Hospital bill/ Report",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Hospital Discharge card",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Heart Relief",
//       documentData: [
//         {
//           documentType: "Policy /Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Doctor Prescription",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Medicine Bill",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Hospital bill/ Report",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Hospital Discharge card",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Education Relief Form Jr kg Sr kg",
//       documentData: [
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Fee Receipt",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Education Relief Form New 1 to 4",
//       documentData: [
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Fee Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "School /College Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Education Relief Form 5 to 15",
//       documentData: [
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Fee Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "School /College Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Education Relief Form Further studies Post Graduation",
//       documentData: [
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Fee Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "College or Institute Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Education Relief Form Reloving Loan",
//       documentData: [
//         {
//           documentType: "Repayment Applicable",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "School /College Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "College or Institute Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },
//     {
//       subSahayName: "Tutorial Releief Form New SSC & HSC",
//       documentData: [
//         {
//           documentType: "Last Mark Sheet",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Cheque",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType: "Fee Receipt",
//           file:[],
//           isUpload: false,
//         },
//         {
//           documentType:
//             "Tutorial Class / Institute Bonafide Certificate with Fees Structure",
//           file:[],
//           isUpload: false,
//         },
//       ],
//     },

// ];
